import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  mode: 'history',
  // base: '/yibo/',
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      path: "/",
      name: "PageView",
      component: resolve => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home"
        },
        {
          path: "/home",
          name: "home",
          component: resolve => require(["@/view/HomePage"], resolve),
          meta: {
            title: "沈阳一博科技有限公司"
          }
        },
        {
          path: "/software",
          name: "software",
          component: resolve => require(["@/view/Software"], resolve),
          meta: {
            title: "关于一博",
            keepAlive: false
          },
          
        },
        {
          path: "/serviceCenter",
          name: "serviceCenter",
          component: resolve => require(["@/view/ServiceCenter"], resolve),
          meta: {
            title: "咨询服务",
            keepAlive: false
          },
          
        },
        // {
        //   path: "/wap/index",
        //   name: "wapIndex",
        //   component: resolve => require(["@/view/wap/index"], resolve),
        //   meta: {
        //     title: "沈阳一博科技有限公司",
        //     keepAlive: false
        //   },
          
        // },
        {
          path: "/servicedetail",
          name: "servicedetail",
          component: resolve => require(["@/view/ServiceDetail"], resolve),
          meta: {
            title: "咨询服务",
            keepAlive: false
          }
        },
        {
          path: "/healthScience",
          name: "healthScience",
          component: resolve => require(["@/view/HealthScience"], resolve),
          meta: {
            title: "产品中心",
            keepAlive: false
          }
         
        },
        {
          path: "/healthScienceDetail",
          name: "healthScienceDetail",
          component: resolve => require(["@/view/HealthScienceDetail"], resolve),
          meta: {
            title: "产品中心",
            keepAlive: false
          },
         
        },
        {
          path: "/gcal",
          name: "gcal",
          component: resolve => require(["@/view/Gcal"], resolve),
          meta: {
            title: "成功案例",
            keepAlive: false
          }
         
        },
        {
          path: "/gcalDetail",
          name: "gcalDetail",
          component: resolve => require(["@/view/GcalDetail"], resolve),
          meta: {
            title: "成功案例",
            keepAlive: false
          },
         
        },
        {
          path: "/cooperation",
          name: "cooperation",
          component: resolve => require(["@/view/Cooperation"], resolve),
          meta: {
            title: "新闻资讯",
            keepAlive: false
          },
          
        },
        {
          path: "/cooperationDetail",
          name: "cooperationDetail",
          component: resolve => require(["@/view/CooperationDetail"], resolve),
          meta: {
            title: "新闻资讯",
            keepAlive: false
          },
          
        },
        {
          path: "/service",
          name: "service",
          component: resolve => require(["@/view/Service"], resolve),
          meta: {
            title: "资质荣誉",
            keepAlive: false
          }
        },
        // {
        //   path: "/newsinformation",
        //   name: "newsinformation",
        //   component: resolve => require(["@/view/NewsInformation"], resolve),
        //   meta: {
        //     title: "新闻动态"
        //   }
        // },
        // {
        //   path: "/companyintroduction",
        //   name: "companyintroduction",
        //   component: resolve =>
        //     require(["@/view/CompanyIntroduction"], resolve),
        //   meta: {
        //     title: "公司介绍"
        //   }
        // },
        {
          path: "/data",
          name: "data",
          component: resolve => require(["@/view/Data"], resolve),
          meta: {
            title: "数据查询",
            keepAlive: false
          }
        },
        {
          path: "/dataShow",
          name: "dataShow",
          component: resolve => require(["@/view/DataShow"], resolve),
          meta: {
            title: "数据查询",
            keepAlive: false
          }
        },
        {
          path: "/recruitment",
          name: "recruitment",
          component: resolve => require(["@/view/Recruitment"], resolve),
          meta: {
            title: "人力资源",
            keepAlive: false
          }
        },
        {
          path: "/recruitmentAdd",
          name: "recruitmentAdd",
          component: resolve => require(["@/view/RecruitmentAdd"], resolve),
          meta: {
            title: "人力资源",
            keepAlive: false
          }
        },
        {
          path: "/contactus",
          name: "contactus",
          component: resolve => require(["@/view/ContactUs"], resolve),
          meta: {
            title: "联系我们"
          }
        },
       
        {
          path: "/servicedtl",
          name: "servicedtl",
          component: resolve => require(["@/view/ServiceDtl"], resolve),
          meta: {
            title: "商品详情"
          }
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js